<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="bars"/>
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box d-flex justify-content-center">
    </div>

    <div class="user-settings">
<!--      <a @click="syncData" class="burger mx-3" >-->
<!--        <span class="notification-badge bg-warning">{{ requestCount }}</span>-->
<!--        <font-awesome-icon icon="bell"/>-->
<!--      </a>-->

      <button @click="syncData" class="burger">
        <font-awesome-icon icon="arrows-rotate"/>
      </button>
    </div>
  </div>
</template>

<script>


export default {
  name: "NavigationBar",
  props: {
    toggle: {
      type: Function,
      require: true
    },
  },
  methods: {
    syncData() {
      this.$utils.showLoading();
      return window.location.reload(true);
    },
    tawkTo() {
      return window.open('https://tawk.to/LytSupport', '_self');
    }
  }
}
</script>

<style scoped>
.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
  float: right;
  border : none;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

.text-white{
  font-size: 30px;
}
</style>
